import { AiStepSchema } from '@feedyou/schema'

import { search } from './services/search'
import { unsetDialogs } from './services/unsetDialogs'
import { getUsedDialogs } from './services/getUsedDialogs'
import { useFormSchema, useFormUiSchema } from './services/hooks'
import { createStepService } from '../../utils/stepServices/createStepServices'
import {
  useFormSchema as useToolFormSchema,
  useFormUiSchema as useToolFormUiSchema
} from './services/tool/hooks'

export const aiStepServices = createStepService<AiStepSchema, {}>({
  search,

  unsetDialogs,
  getUsedDialogs,

  useFormSchema,
  useFormUiSchema,
  substeps: {
    tool: {
      useFormSchema: useToolFormSchema,
      useFormUiSchema: useToolFormUiSchema
    }
  }
})
